import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./DetailsMain.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../Api.js"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImageandvideoSlider from "../../ExtraComponent/ImageandvideoSlider.jsx"
import DOMPurify from "dompurify";
import { FaCheckCircle } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { getGalleries, OrderProperty, ProfileUser, VerifyPayment } from "../../Services/Operations/ProductAPI.js";
import { useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};
const sanitizeText = (text) =>
  DOMPurify.sanitize(text, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });

const PropertyDetails = () => {
  const { state } = useLocation();

  const { id } = useParams();
  console.log("Property ID from params:", id);
    const { isAuthenticated,token} = useSelector((state) => state.auth);
    const navigate=useNavigate()

  const [galleryImages, setGalleryImages] = useState([]);
  const [PropertyDetails, setPropertyDetails] = useState({});
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  const [open, setOpen] = useState(false);
 const[user,setUser]=useState(null)

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      try {
        const response = await api.get(`developers-property`);
        if (response.data.status === true) {
          const propertyData = response.data.data.find(
            (item) => item.id.toString() === id
          );
          console.log("Fetched Property Data:", propertyData);
          if (propertyData) {
            setPropertyDetails(propertyData);
          } else {
            console.error("Property not found");
          }
        }
      } catch (error) {
        console.error("Property details fetch error", error);
      }
    };
    fetchPropertyDetails();
    const fetchImages = async () => {
      try {
        const response = await getGalleries()
        console.log("Gallery Response:", response.data);
        setGalleryImages(response.data?.data || []);
      } catch (error) {
        console.error("Gallery fetch error", error);
        setGalleryImages([]);
      }
    };
    fetchImages();

       const handleGetProfile=async()=>{
      try {
          const res =await ProfileUser(token)
          console.log('handleGetProfile',res);
          setUser(res.data.data)
         console.log(isAuthenticated,user);
                 setFormData({
          name: res.data.data.full_name,
          phone: res.data.data.phone,
          email: res.data.data.email,
          message: "",
          request_type: "",
        });
         
          
      } catch (error) {
         console.log(error);
          
      }
    }

    handleGetProfile()
  }, []);

  const filteredArray = galleryImages.filter(
    item => item.property_name === PropertyDetails?.property_name
  );

  console.log("Filtered Gallery:", filteredArray);

  const propertyGallery = filteredArray;
  const imagesOnly = propertyGallery.filter(item => item.media_type === "image");
  const videosOnly = propertyGallery.filter(item => item.media_type === "video");
  console.log("video link are: ", videosOnly);

  const mainMedia =videosOnly[0] || imagesOnly[0] || null;



  // form validation and submit


  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  // 🔹 Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // 🔹 Validation
  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "Enter valid 10 digit phone number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }

    if (!formData.request_type) {
      newErrors.request_type = "Please select a request type";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🔹 Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setSuccessMsg("");
          const payload = {
        ...formData,
        property_id:id,
      };

    try {

      console.log("Submitting Inquiry with payload:", payload);
      alert("your inquiry is submitted successfully")
              setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        
        });
      return;
      const response = await api.post(
        "/real-estate-property-enquiry",
        payload
      );

      if (response?.data?.status === true) {
        toast.success("Inquiry submitted successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });

        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        
        });
      }

    } catch (error) {
      console.error("Inquiry Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

 const handleOrderEnquiry=async()=>{
    try {
      if(!token){
        toast.warning("Unauthorized login first")
        navigate("/login")
      }
      let data={
        property_id:Number(id),
       
      }
      console.log(data);
      
      const res= await OrderProperty(data,token)
      console.log(res);
      if(res.status===200){
        toast.success("Order created successsfully")
        handlePayment(res.data)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }


        const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const verifyPayment=async(data)=>{
try {
  if(!token){
     toast.warning("Unauthorized login first")
        navigate("/login")
  }
  console.log(data);
  const res= await VerifyPayment(data,token)
  console.log(res);
  if(res.status===200){
    toast.success(
"Payment successful & property booked")
  }
  
  
} catch (error) {
  console.log(error);
  
}
}


  const handlePayment = async (data) => {
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load");
      return;
    }

    // Call your backend to create order
    // const data = await fetch("/api/create-order", {
    //   method: "POST",
    // }).then((t) => t.json());

    const options = {
      key: data.key, // from Razorpay dashboard
      amount: data.amount,
      currency: "INR",
      name: "Siance Sofoware",
      description: "Test Transaction",
      order_id: data.order_id,

      handler: function (response) {
        console.log("Payment Success:", response);
         verifyPayment(response)
        // send this response to backend for verification
        // response.razorpay_payment_id
        // response.razorpay_order_id
        // response.razorpay_signature
      },
 
      prefill: {
        name: "John Doe",
        email: "john@example.com",
        contact: "9999999999",
      },

      theme: {
        color: "#3399cc",
      },
    };

   

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };
  const [currentImages, setCurrentImages] = useState([]);



  const parseNearbyPlaces = (data) => {
    try {
      return JSON.parse(data || "[]");
    } catch (e) {
      console.error("Invalid nearby_places JSON", e);
      return [];
    }
  };

  const nearbyPlaces = parseNearbyPlaces(PropertyDetails?.nearby_places);


  // EMI MODAL STATES
  // EMI STATES
  const [showEmiModal, setShowEmiModal] = useState(false);
  const [propertyPrice, setPropertyPrice] = useState(0);
  const [interestRate, setInterestRate] = useState(7);
  const [tenureYears, setTenureYears] = useState(10);

  // Update price after API load
  useEffect(() => {
    if (PropertyDetails?.price) {
      setPropertyPrice(Number(PropertyDetails.price));
    }
  }, [PropertyDetails.price]);

  const advanceAmount = propertyPrice * 0.10;
  const loanAmount = propertyPrice * 0.90;

  const monthlyRate = interestRate / 12 / 100;
  const totalMonths = tenureYears * 12;

  const emi =
    loanAmount > 0
      ? (loanAmount *
        monthlyRate *
        Math.pow(1 + monthlyRate, totalMonths)) /
      (Math.pow(1 + monthlyRate, totalMonths) - 1)
      : 0;


       const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };


  return (
    <div className="PropertyDetails">

      <ImageandvideoSlider
        open={open}
        setOpen={setOpen}
        media={propertyGallery}
      />

      <motion.main
        className="pd-wrapper"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.15 }}
      >
        {/* LEFT */}
        <motion.div className="pd-left" variants={fadeUp}>
          <motion.div className="pd-header" variants={fadeUp}>
            <h1 className="pd-title">
              {PropertyDetails?.property_name}
            </h1>

            <div className="pd-address">
              <HiOutlineLocationMarker className="pd-icon" />
              <span>{PropertyDetails?.location}</span>
            </div>
          </motion.div>

          {/* GALLERY */}
          <motion.div className="pd-gallery" variants={fadeUp}>
            {/* MAIN MEDIA */}
            <motion.div
              className="pd-main-media"
              whileHover={{ scale: 1.03 }}
            >
           
       <div
  style={{
    display: "flex",
    width: "40vw",
    overflowX: "auto",
    gap: "16px",
    padding: "10px",
  }}
>
  {galleryImages.map((item) => (
    <div
      key={item.id}
      style={{
        flex: "0 0 280px", // 🔥 FIX: prevents shrink + sets card width
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        overflow: "hidden",
      }}
    >
      {/* MEDIA */}
      <div style={{ width: "100%", height: "200px" }}>
        {item.media_type === "image" ? (
          <img
            src={item.media_url}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <video
            controls
            preload="metadata"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          >
            <source src={item.media_url} type="video/mp4" />
          </video>
        )}
      </div>

      {/* INFO */}
      <div style={{ padding: "12px", textAlign: "center" }}>
        {/* <h4 style={{ margin: "0 0 5px", fontSize: "15px" }}>
          {item.property_name}
        </h4> */}

        <p style={{ margin: 0, fontSize: "12px", color: "#888" }}>
          {new Date(item.created_at).toLocaleDateString()}
        </p>
      </div>
    </div>
  ))}
</div>
       
            </motion.div>


            {/* THUMBNAILS (IMAGES ONLY) */}
            <div className="pd-thumb-grid">
              {imagesOnly.slice(1, 5).map((img, i) => (
                <motion.div
                  className="pd-thumb"
                  key={i}
                  whileHover={{ scale: 1.05 }}
                >
                  <img
                    src={img.media_url}
                    alt="Property"
                    onClick={() => setOpen(true)}
                  />

                  {i === 3 && imagesOnly.length > 5 && (
                    <button
                      className="pd-show-btn"
                      onClick={() => setOpen(true)}
                    >
                      Show all photos
                    </button>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>


          {/* META */}
          <motion.div className="pd-meta" variants={fadeUp}>
            <span>{PropertyDetails?.no_of_beds} Beds</span>
            <span>{PropertyDetails?.no_of_bathroom} Bathrooms </span>
            <span>{PropertyDetails.plot_size} sqft</span>
          </motion.div>

          {/* AMENITIES */}
          <motion.section className="pd-section" variants={fadeUp}>
            <h3>Facilities</h3>
            <div className="pd-amenities">
              {PropertyDetails?.facilities?.split(",").map((item, index) => (
                <div key={index} className="pd-amenity-item">
                  <FaCheckCircle className="amenity-icon" />
                  <span> {item.trim()}</span>
                </div>
              ))}
            </div>
          </motion.section>

           <button  className="btn-send" disabled={loading}
           onClick={()=>handleOrderEnquiry()}>
                  {loading ? "Loading..." : "Order"}
                </button>

          {/* DESCRIPTION */}
          <motion.section className="pd-section" variants={fadeUp}>
            <h3>Description</h3>
            <p className="pd-description">
              {PropertyDetails?.description}
            </p>
          </motion.section>
          <motion.div className="pd-map-card">
            <h3>Location</h3>
            {/* <iframe
              title="Map"
              loading="lazy"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-0.132%2C51.505%2C-0.09%2C51.52&layer=mapnik"
            /> */}
            <div className="map-section">
              <div
                className="map-container"
                dangerouslySetInnerHTML={{ __html: PropertyDetails.map }}
              />
            </div>



            <div className="pd-nearby">
              <strong>Nearby Places</strong>
              {nearbyPlaces.length > 0 ? (
                <ul className="pd-nearby-list">
                  {nearbyPlaces.map((item, index) => (
                    <li key={index}>
                      <span className="place-name">
                        {sanitizeText(item.place)} -
                      </span>
                      <span className="place-time">
                        {sanitizeText(item.time)} mins
                      </span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No nearby places available</p>
              )}

            </div>
          </motion.div>
        </motion.div>

        {showEmiModal && (
          <motion.div
            className="emi-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="emi-modal"
              initial={{ scale: 0.8, y: 50 }}
              animate={{ scale: 1, y: 0 }}
            >
              <h2>EMI Calculator</h2>

              <label>Property Price (₹)</label>
              <input
                type="number"
                value={propertyPrice}
              // onChange={(e) => setPropertyPrice(Number(e.target.value))}
              />

              <label>Interest Rate (% per year)</label>
              <input
                type="number"
                value={interestRate}
                onChange={(e) => setInterestRate(Number(e.target.value))}
              />

              <label>Tenure (Years)</label>
              <input
                type="number"
                value={tenureYears}
                onChange={(e) => setTenureYears(Number(e.target.value))}
              />

              <div className="emi-results">
                <p><strong>Advance (10%):</strong> ₹{advanceAmount.toFixed(2)}</p>
                <p><strong>Loan (90%):</strong> ₹{loanAmount.toFixed(2)}</p>
                <p><strong>Monthly EMI:</strong> ₹{emi.toFixed(2)}</p>
              </div>

              <div className="emi-actions">
                <button className="pd-btn-primary" onClick={() => setShowEmiModal(false)}>
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}


        {/* RIGHT */}
        <motion.aside className="pd-right" variants={fadeUp}>
          <motion.div className="pd-price-card" whileHover={{ y: -4 }}>
            <div className="pd-price-top">
              <div>
                <h2 style={{ textAlign: "left" }}>₹{PropertyDetails.price}/-</h2>
                <span>EMI: ₹{emi.toFixed(2)}/month</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {/* <small>Listed by</small>
                <strong>Dhanushdhari Rental</strong> */}

              </div>
            </div>

            <div className="pd-actions">
              <button className="pd-btn-primary" style={{ backgroundColor: "green" }} onClick={() => setShowEmiModal(true)}>Calculate EMI</button>
              <button className="pd-btn-primary">Pay Advance(₹{advanceAmount.toFixed(2)})</button>
              {/* <button className="pd-btn-outline">Contact Owner</button>
               */}
            </div>

            <p className="pd-note">
              Security deposit and fees may apply.
            </p>
          </motion.div>
          <motion.div className="Form_container">
            <h4 style={{ textAlign: "center", color: "green", paddingBottom: "5px" }}>Send Inquiry</h4>
            <form className="inquiry-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                className="inquiry-input"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <small className="error">{errors.name}</small>}

              <input
                type="text"
                name="phone"
                placeholder="Phone"
                className="inquiry-input"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <small className="error">{errors.phone}</small>}

              <input
                type="email"
                name="email"
                placeholder="Email"
                className="inquiry-input"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <small className="error">{errors.email}</small>}

              <textarea
                name="message"
                className="inquiry-textarea"
                placeholder="Enter Message.."
                value={formData.message}
                onChange={handleChange}
              />

              <select
                name="request_type"
                className="inquiry-select"
                value={formData.request_type}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="visit">Request a Visit</option>
                <option value="details">Request More Details</option>
              </select>
              {errors.request_type && (
                <small className="error">{errors.request_type}</small>
              )}

              <p className="inquiry-terms">
                By submitting this form I agree to <a href="#">Terms of Use</a>
              </p>

              {successMsg && <p className="success">{successMsg}</p>}

              <div className="inquiry-buttons">
                <button type="submit" className="btn-send" disabled={loading}>
                  {loading ? "Sending..." : "Send Message"}
                </button>
                <button type="button" className="btn-send">Call</button>
              </div>

              <button type="button" className="btn-whatsapp">WhatsApp</button>
            </form>

          </motion.div>

        </motion.aside>
      </motion.main>

    </div>

  );
};

export default PropertyDetails;
